export default __webpack_public_path__ + "0311dd050b804caeb806fae9760ea4e0.png";